import NotificationDetailsView from "@/components/Templates/Notifications/NotificationDetailsView";

const NotificationDetails = () => {
	return <NotificationDetailsView />;
};

export default NotificationDetails;
